import React from "react";
import { resolvePromotionBadge } from "../presentation/promotion";

const PromotionBadge = ({ quote, settings, language, label, color }) => {
  const badge = resolvePromotionBadge({ quote, settings, language, label });
  if (!badge) return null;
  return (
    <span
      data-promotion-mode={badge.mode}
      style={{
        backgroundColor:
          color ||
          badge.color ||
          settings.discount_tag_color ||
          settings.dark ||
          "#0099cc",
        borderRadius: 4,
        color: "white",
        display: "inline-block",
        fontSize: 12,
        fontWeight: 700,
        lineHeight: "18px",
        maxWidth: "100%",
        flexShrink: 0,
        padding: "1px 6px",
        whiteSpace: "normal",
      }}
    >
      {badge.text}
    </span>
  );
};

export default PromotionBadge;
